

const TumblrQuote = (props) => {
  return (
      <a href={props.link} target="_blank" rel="noopener noreferrer" className="btn btn-dark" id="tumblr-quote">
        <i className="fa fa-tumblr"></i>
      </a>
  );
};

export default TumblrQuote;